import { apiRequest } from './apiClient';

export async function fetchMailIds() {
  const result = await apiRequest('/mail-ids');
  return result.data;
}

export async function createMailId(data) {
  const result = await apiRequest('/mail-ids', { method: 'POST', body: JSON.stringify(data) });
  return result.data;
}

export async function updateMailId(id, data) {
  const result = await apiRequest(`/mail-ids/${id}`, { method: 'PATCH', body: JSON.stringify(data) });
  return result.data;
}
